(function () {
    'use strict';

    angular
        .module('app')
        .controller('EntityChangeHistoryDialogCtrl', EntityChangeHistoryDialogCtrl);

    EntityChangeHistoryDialogCtrl.$inject = ['DialogInstance', 'title', 'entityId', 'updatedDateFrom'];

    /**
     * Dialog for showing history of change for a given entity.
     *
     * @param {string} title - Title for the dialog.
     * @param {number} entityId
     * @param {date} updatedDateFrom - The date after which to show history. I.e. don't show changes from before this date.
     */
    function EntityChangeHistoryDialogCtrl(DialogInstance, title, entityId, updatedDateFrom) {
        /* jshint validthis:true */
        var vm = this;
        vm.ok = ok;
        vm.entityId = entityId;
        vm.updatedDateFrom = updatedDateFrom;
        vm.title = title;

        function ok() {
            DialogInstance.ok();
        }
    }
})();
